<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M5.5 2.5C3.84315 2.5 2.5 3.84315 2.5 5.5V19.5C2.5 21.1569 3.84315 22.5 5.5 22.5H19.5C21.1569 22.5 22.5 21.1569 22.5 19.5V5.5C22.5 3.84315 21.1569 2.5 19.5 2.5H5.5ZM8.16167 20.2958C8.45245 20.2958 8.68816 20.0601 8.68816 19.7693V10.3745C8.68816 10.0837 8.45245 9.848 8.16167 9.848H5.92051C5.62973 9.848 5.39402 10.0837 5.39402 10.3745V19.7693C5.39402 20.0601 5.62973 20.2958 5.92051 20.2958H8.16167ZM7.04249 8.96228C5.86663 8.96228 4.91338 8.00903 4.91338 6.83317C4.91338 5.65731 5.86663 4.70406 7.04249 4.70406C8.21836 4.70406 9.1716 5.65731 9.1716 6.83317C9.1716 8.00903 8.21841 8.96228 7.04249 8.96228ZM19.9175 20.2959C20.1848 20.2959 20.4016 20.0792 20.4016 19.8118V15.2649V15.2314C20.4017 13.2478 20.4019 9.69047 16.5727 9.69047C14.8337 9.69047 14.017 10.3271 13.4674 11.1518V10.3322C13.4674 10.0649 13.2506 9.84812 12.9833 9.84812H10.6573C10.39 9.84812 10.1732 10.0649 10.1732 10.3322V19.8118C10.1732 20.0792 10.39 20.2959 10.6573 20.2959H12.9833C13.2507 20.2959 13.4674 20.0792 13.4674 19.8118V14.7292C13.5277 14.0462 13.8284 12.5245 15.3105 12.5245C17.0805 12.5245 17.0455 14.4322 17.0307 15.2359C17.0295 15.2998 17.0285 15.3567 17.0285 15.4051V19.8118C17.0285 20.0792 17.2452 20.2959 17.5126 20.2959H19.9175Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgLinkedin',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
